<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <MyForm ref="form" :form="form" :rules="rules" :labelWidth="labelWidth" :formGroups="[{ formCtrl }]"
      :viewMode="viewMode">
    </MyForm>

    <div class="btns">
      <SubmitBtn :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  name: "FixdDtail",
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'custom',
      breadcrumb: [
        { name: "客户管理", path: `/customer/manage` },
        { name: "客户列表", path: `/customer/manage` },
        { name: "添加客户" },
      ],
      form: {
        name: undefined,
        tradeid: undefined,
        member: undefined,
        phone: undefined,
        product: undefined,
        address: undefined,
      },
      rules: {
        name: [
          { required: true, message: "请填写公司名称", trigger: "blur" },
        ],
        tradeid: [
          { required: true, message: "请选择所在行业", trigger: "blur" },
        ],
        member: [
          { required: true, message: "请填写联系人", trigger: "blur" },
        ],
        phone: [
          { required: true, validator: this.checkPhone, trigger: "blur" },
        ],
        product: [
          { required: true, message: "请填写主营产品", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请填写公司地址", trigger: "blur" },
        ],
      },
      formCtrl: [
        {
          label: "公司名称",
          keyName: "name",
          err: "请填写公司名称",
          type: "text",
        },
        {
          label: "所属队长",
          keyName: "fleet",
          type: "select",
          options: [],
        },
        {
          label: "所在行业",
          keyName: "tradeid",
          type: "select",
          options: [],
        },
        // {
        //   label: "成立时间",
        //   keyName: "starttime",
        //   err: "请选择成立时间",
        //   type: "month",
        // },
        {
          label: "联系人",
          keyName: "member",
          err: "请填写联系人",
          type: "text",
        },
        {
          label: "联系电话",
          keyName: "phone",
          err: "请填写联系电话",
          type: "number",
        },
        {
          label: "主营产品",
          keyName: "product",
          err: "请填写主营产品",
          type: "text",
        },
        {
          label: "公司地址",
          keyName: "address",
          err: "请填写公司地址",
          type: "text",
        },
        {
          label: "QQ",
          keyName: "qq",
          err: "请填写QQ",
          type: "number",
        },
        {
          label: "微信",
          keyName: "wechat",
          err: "请填写微信号",
          type: "text",
        },
        // {
        //   label: "客户来源",
        //   keyName: "custcurse",
        //   type: "select",
        //   options: [],
        // },
        // {
        //   label: "跟进状态",
        //   keyName: "followstate",
        //   type: "select",
        //   options: [],
        // },
        // {
        //   label: "客户属性",
        //   keyName: "custtype",
        //   type: "select",
        //   options: [],
        // },
        // {
        //   label: "成交状态",
        //   keyName: "status",
        //   type: "select",
        //   options: [],
        // },
        // {
        //   label: "注意事项",
        //   keyName: "careful",
        //   err: "请填写注意事项",
        //   type: "textarea",
        // },
      ],
      getOptionUrl: 'index',
    };
  },
  methods: {
    paramsPackage(params, object) {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key]
          params[key] = value;
        }
      }

      params['headers'] = {
        'X-Method': 'create',
        'X-Module': 'custom',
      }
    },

    setOptions({ team, industry, customcur, followstate, customtype, trans }) {
      this.formCtrl.map(c => {
        if (c.keyName == 'fleet' && team.length) {
          c.options = team.map(v => {
            return {
              label: v.nickname + '的客户',
              value: v.id,
            }
          })
          this.form[c.keyName] = c.options[0].value
        }
        if (c.keyName == 'tradeid' && industry.length) {
          c.options = industry.map(v => {
            return {
              label: v.name,
              value: v.id,
            }
          })
        }
        if (c.keyName == 'custcurse' && customcur.length) {
          c.options = customcur.map(v => {
            return {
              label: v.name,
              value: v.id,
            }
          })
          this.form[c.keyName] = c.options[0].value
        }
        if (c.keyName == 'followstate' && followstate.length) {
          c.options = followstate.map(v => {
            return {
              label: v.name,
              value: v.id,
            }
          })
          this.form[c.keyName] = c.options[0].value
        }
        if (c.keyName == 'custtype' && customtype.length) {
          c.options = customtype.map(v => {
            return {
              label: v.name,
              value: v.id,
            }
          })
          this.form[c.keyName] = c.options[0].value
        }
        if (c.keyName == 'status' && trans.length) {
          c.options = trans.map(v => {
            return {
              label: v.name,
              value: v.id,
            }
          })
        }
        this.$forceUpdate()
      })
    },
  },
  mounted() {
    this.getOptions()
  },
};
</script>

<style lang="less" scoped>
.btns {
  margin: 40px 0 60px 180px;
}
</style>
